import { render } from "./AdminOrderCardDetails.vue?vue&type=template&id=1d69a711&scoped=true"
import script from "./AdminOrderCardDetails.vue?vue&type=script&lang=js"
export * from "./AdminOrderCardDetails.vue?vue&type=script&lang=js"

import "./AdminOrderCardDetails.vue?vue&type=style&index=0&id=1d69a711&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d69a711"]])

export default __exports__